import { IItemLocalization, ILanguage } from '../api/grpc';

export { ILanguage, IItemLocalization };

export class Language implements ILanguage {
  Code?: string;
  Name?: string;
  Title?: string;

  constructor(data: ILanguage) {
    Object.assign(this, data);
  }
}

export class ItemLocalization implements IItemLocalization {
  Key?: string;
  Value?: string;

  constructor(data: IItemLocalization) {
    Object.assign(this, data);
  }
}
